import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { INewBody } from '../../components/FormMapping/validation';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

export default function useUpdateMapping() {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  async function execute(
    distributorId: string,
    mappingId: string,
    body: INewBody,
  ) {
    try {
      setLoading(true);
      const response = await api.put(
        `v1/backoffice/mapping/${distributorId}/${mappingId}`,
        {
          ...body,
        },
      );

      if (response.status === 200) {
        toast.success(ToastMessages.mapping.success.updateMapping);
        history.goBack();
      }
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.error(ToastMessages.mapping.error.updateMapping);
      } else {
        toast.error(ToastMessages.general.error.genericError);
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
